import * as React from 'react'
import DashboardLayout from '../../layouts/dashboard_layout'

export const MainPage = (props: any) => {
  return (
    <DashboardLayout>
      <div>Main Page</div>
    </DashboardLayout>
  )
}